jQuery(document).ready(function ($){    
  $.noConflict();
       document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });

  let options = {
    rootMargin: "0px",
    threshold: 0,
  };
  
  let callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && target.muted === false) {
        target.muted = true;
      }
    });
  };
  
  let observer = new IntersectionObserver(callback, options);
  let target = document.querySelector("#nm-mp4");

  if (target !== null) {
    observer.observe(target);
  }

  $(".checkout .edit_checkout .checkbox__label[for='checkout_buyer_accepts_marketing']").text("Email me with news and offers from the LAPD Store and LAPD");
  $(document).on("page:load page:change", function(event) {
    $(".checkout .edit_checkout .checkbox__label[for='checkout_buyer_accepts_marketing']").text("Email me with news and offers from the LAPD Store and LAPD");
  });

});